import useSWR from 'swr';
import assignTicket from 'modules/emergencies/api/assignTicket';
import { Modal } from 'react-async-popup';
import '../ui/emergencyPopup.css';

// logic
import getUsersToAssign from 'modules/emergencies/api/getUsersToAssign';
import { getUserName } from '../ticketsList/ticketsListTable/utils/user';
import { AssignAgentModal } from './assignAgentModal';
import assignTicketRegion from 'modules/emergencies/api/assignTicketRegion';

// returns users with loading/reloading state
const useAssignAgentModal = (ticket, reset) => {
  const { data: users, error: assignAgentError } = useSWR(
    `price-negotiation/users/`,
    getUsersToAssign,
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const isLoadingUsersToAssign = typeof users === 'undefined' && !assignAgentError;
  let usersOptions = [];
  if (users) {
    usersOptions = (users?.results || []).map((user) => ({
      value: user.id,
      label: getUserName(user),
      display: getUserName(user),
      search: getUserName(user),
    }));
  }

  // open modal
  const assignModalProps = { usersOptions, isLoadingUsersToAssign, assignAgentError, ticket };
  const assignAgent = async () => {
    const { show } = await Modal.new({
      content: <AssignAgentModal assignModalProps={assignModalProps} />,
      footer: null,
    });
    const result = await show();
    return result;
  };

  const openModalAssignUser = async () => {
    const result = await assignAgent();
    if (result) {
      const agent_id = result.agent_id;
      const working_area = result.working_area;
      const assignTicketDto = {
        ticket_ids: [ticket.id],
        agent_id,
      };
      if (agent_id && agent_id !== -1) await assignTicket({ assignTicketDto });
      if (working_area !== -1)
        await assignTicketRegion({
          assignTicketRegionDto: {
            working_areas: [working_area],
          },
          ticket_id: ticket.id,
        });
      // we are mutating the tickets cache so it will reload automatically
      reset();
    }
  };

  const onSubmit = async () => {};

  const onCancel = async () => {};

  return {
    users,
    usersOptions,
    isLoadingUsersToAssign,
    assignAgentError,
    openModalAssignUser,
    onSubmit,
    onCancel,
  };
};

export default useAssignAgentModal;
